// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"36":"0f602c80","104":"cfc99105","153":"6f2508ca","283":"eaa960e0","286":"e817de91","288":"ac29363a","428":"267f0348","485":"dc133f99","581":"c65d35e7","665":"19c0d24e","672":"7baf982a","693":"c3277d51","734":"c99ed606"}[chunkId] + ".js";
};